<template>
  <div>
    <div class="content_box">
      <div class="transportation_box_l">
        <el-tooltip
          class="item"
          v-for="(item, index) in circuitData"
          :key="index"
          effect="dark"
          :content="item.name"
          placement="top-start"
        >
          <div class="transportation_box" @click="selectRouter(item)">
            <div v-if="item.type == 1 || item.type == 4">
              <el-badge
                v-if="
                  (item.type == 1 || item.type == 4) && item.ordernumber > 0
                "
                :value="item.ordernumber"
                class="item"
              >
                <img
                  v-if="item.photo"
                  :src="item.photo"
                  :class="
                    router == item.id ? 'img_size box_shadow' : 'img_size'
                  "
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/img/route1.jpg"
                  :class="
                    router == item.id ? 'img_size box_shadow' : 'img_size'
                  "
                  alt=""
                />
              </el-badge>
              <img
                v-if="item.photo && item.ordernumber == 0"
                :src="item.photo"
                :class="router == item.id ? 'img_size box_shadow' : 'img_size'"
                alt=""
              />
              <img
                v-if="!item.photo && item.ordernumber == 0"
                src="@/assets/img/route1.jpg"
                :class="router == item.id ? 'img_size box_shadow' : 'img_size'"
                alt=""
              />
            </div>
            <div v-if="item.type == 2 || item.type == 3">
              <el-badge
                v-if="
                  (item.type == 2 || item.type == 3) && item.batchnumber > 0
                "
                :value="
                  item.type == 1 || item.type == 4
                    ? item.ordernumber
                    : item.batchnumber
                "
                class="item"
              >
                <img
                  v-if="item.photo"
                  :src="item.photo"
                  :class="
                    router == item.id ? 'img_size box_shadow' : 'img_size'
                  "
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/img/route1.jpg"
                  :class="
                    router == item.id ? 'img_size box_shadow' : 'img_size'
                  "
                  alt=""
                />
              </el-badge>
              <img
                v-if="item.photo && item.batchnumber == 0"
                :src="item.photo"
                :class="router == item.id ? 'img_size box_shadow' : 'img_size'"
                alt=""
              />
              <img
                v-if="!item.photo && item.batchnumber == 0"
                src="@/assets/img/route1.jpg"
                :class="router == item.id ? 'img_size box_shadow' : 'img_size'"
                alt=""
              />
            </div>

            <div :class="router == item.id ? 'color1 text_iop' : 'text_iop'">
              {{ item.name }}
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>

              <input
                v-model="screen.ordernumber"
                type="text"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内运单号</div>

              <input
                v-model="screen.domesticnumber"
                type="text"
                placeholder="请输入国内运单号"
                class="table_item_input"
              />
            </div>
          </div>

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" round class="round_btn" @click="scarch"
                >搜索</el-button
              >
              <el-button round @click="reset">重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">
          待确认{{ routerType == 2 || routerType == 3 ? "批次" : "包裹" }}列表
        </div>
      </div>
      <!-- //批次列表 -->
      <div class="table_box" v-if="routerType == 2 || routerType == 3">
        <el-table
          v-loading="tableLoading"
          :key="2"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="name" label="批次号">
          </el-table-column>
          <el-table-column align="center" prop="intnumber" label="国际快递单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="intcarrier"
            label="国际快递公司"
          >
          </el-table-column>
          <el-table-column align="center" prop="number" label="包裹数">
          </el-table-column>
          <el-table-column align="center" prop="paidweightkg" label="收费重量">
          </el-table-column>
          <el-table-column align="center" prop="addoncost" label="直邮附加费">
          </el-table-column>
          <el-table-column align="center" prop="duty" label="关税">
          </el-table-column>
          <el-table-column align="center" prop="hebaocost" label="包运费">
          </el-table-column>
          <el-table-column align="center" prop="insurancefee" label="保险">
          </el-table-column>
          <el-table-column align="center" prop="storagecost" label="仓库附加费">
          </el-table-column>
          <el-table-column align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="confirmOrder(scope.row.id, 1)"
                title="是否确认包裹信息？"
              >
                <el-button
                  class="round_btn"
                  type="primary"
                  size="small "
                  round
                  slot="reference"
                  >去确认</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column align="center" label="详情">
            <template slot-scope="scope">
              <el-button type="text" @click="tobeath(scope.row)"
                >批次详情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系客服">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                title="客服热线"
                width="200"
                trigger="click"
              >
                <div>
                  <div>{{ serviceData }}</div>
                  <div style="white-space: pre-line">{{ serviceDataInfo }}</div>
                </div>

                <el-button
                  slot="reference"
                  @click="service(scope.row.routeid)"
                  type="text"
                  >联系客服</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
      <!-- //包裹列表 -->
      <div class="table_box" v-if="routerType == 1 || routerType == 4">
        <el-table
          v-loading="tableLoading"
          :key="1"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          :data="orderData.content"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" prop="datecreated" label="创建日期">
          </el-table-column>
          <el-table-column align="center" prop="ordernumber" label="单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domesticnumber"
            label="国内单号"
          >
          </el-table-column>
          <el-table-column align="center" prop="recipientname" label="收件人">
          </el-table-column>

          <el-table-column align="center" prop="itemNames" label="包裹内件">
          </el-table-column>
          <el-table-column align="center" prop="shippingcost" label="运费">
          </el-table-column>
          <el-table-column align="center" prop="stateValue" label="包裹状态">
            <template slot-scope="scope">待确认 </template>
          </el-table-column>

          <el-table-column align="center" prop="actionreason" label="原因">
          </el-table-column>

          <el-table-column align="center" width="100" label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="confirmOrder(scope.row.id, 2)"
                title="是否确认包裹信息？"
              >
                <el-button
                  class="round_btn"
                  type="primary"
                  size="small "
                  round
                  slot="reference"
                  >去确认</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column align="center" label="详情">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="todetails(scope.row.id, scope.row.name)"
                >包裹详情</el-button
              >
              <el-button @click="logistics(scope.row)" type="text"
                >物流详情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系客服">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                title="客服热线"
                width="200"
                trigger="click"
              >
                <div>
                  <div>{{ serviceData }}</div>
                  <div style="white-space: pre-line">{{ serviceDataInfo }}</div>
                </div>

                <el-button
                  slot="reference"
                  @click="service(scope.row.routeid)"
                  type="text"
                  >联系客服</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
// import routeimg from '@/assets/img/route1.jpg'
export default {
  data() {
    return {
      tableLoading: "",
      routerType: "",
      // routeimg:routeimg,
      table: 2,
      serviceDataInfo: "",
      serviceData: "",
      router: "",
      page: 1,
      circuitData: [],
      orderData: [],
      dialogVisible: false,
      screen: {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: "",
        state: 60,
      },
      screenBeath: {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: "",
        grouptype: 25,
      },
      supportWechat: "",
    };
  },
  created() {
    // this.orderList();
    this.circuit();
  },
  methods: {
    // 物流详情
    logistics(item) {
      localStorage.setItem("order", JSON.stringify(item));
      this.$router.push({
        path:
          "/logistics/logistics?code=" +
          item.domesticcarrier +
          "&num=" +
          item.domesticnumber,
      });
    },
    //筛选
    scarch() {
      if (this.routerType == 2 || this.routerType == 3) {
        this.screenBeath.domesticnumber = this.screen.domesticnumber;
        this.screenBeath.ordernumber = this.screen.ordernumber;
        this.batchList();
      } else if (this.routerType == 1 || this.routerType == 4) {
        this.orderList();
      }
    },
    reset() {
      var clickIndex = this.router;
      this.screen = {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: clickIndex,
        state: 60,
      };
      this.screenBeath = {
        page: 1,
        size: 10,
        domesticnumber: "",
        ordernumber: "",
        routeid: clickIndex,
        grouptype: 25,
      };
      if (this.routerType == 2 || this.routerType == 3) {
        this.batchList();
      } else if (this.routerType == 1 || this.routerType == 4) {
        this.orderList();
      }
    },
    //点击确认订单
    confirmOrder(e, index) {
      if (index == 1) {
        var data = {
          batchId: e,
        };
        crudDept.confirmBatch(data).then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.batchList();
        });
      } else if (index == 2) {
        var data = {
          orderId: e,
        };
        crudDept.confirmOrder(data).then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.orderList();
        });
      }
    },
    //点击线路
    selectRouter(item) {
      this.router = item.id;
      this.routerType = item.type;
      this.screen.routeid = item.id;
      this.screenBeath.routeid = item.id;
      if (this.routerType == 2 || this.routerType == 3) {
        this.batchList();
      } else if (this.routerType == 1 || this.routerType == 4) {
        this.orderList();
      }
    },

    //g根据线路获取客服字段
    service(e) {
      if (e) {
        this.supportWechat = e;
        this.circuitw();
      }
    },
    circuitw() {
      var data = {
        page: 1,
        size: 1,
        id: this.supportWechat,
      };
      crudDept.circuit(data).then((res) => {
        this.serviceData = res.content[0].supportWechat;
        this.serviceDataInfo = res.content[0].description;
      });
    },

    //线路
    circuit() {
      var data = {
        page: this.page,
        size: 100,
        state: 60,
        grouptype: 25,
      };
      crudDept.gerRouteNumber(data).then((res) => {
        this.circuitData = res.content;
        this.router = res.content[0].id;
        this.routerType = res.content[0].type;
        if (res.content[0].type == 1 || res.content[0].type == 4) {
          this.screen.routeid = res.content[0].id;
          this.orderList();
        } else if (res.content[0].type == 2 || res.content[0].type == 3) {
          this.screen.routeid = res.content[0].id;
          this.batchList();
        }
      });
    },
    //分页
    pageChange(e) {
      this.screenBeath.page = e;
      this.screen.page = e;
      if (this.routerType == 2 || this.routerType == 3) {
        this.batchList();
      } else if (this.routerType == 1 || this.routerType == 4) {
        this.orderList();
      }
    },
    //批次列表
    batchList() {
      this.tableLoading = true;
      crudDept
        .batch(this.screenBeath)
        .then((res) => {
          this.orderData = res;
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
    //订单列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .orderList(this.screen)
        .then((res) => {
          this.orderData = res;
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
    //查看批次详情
    tobeath(item) {
      localStorage.setItem("batch", JSON.stringify(item));
      var name = "待确认订单";
      this.$router.push({
        path:
          "/extractGoods/details?id=" + item.id + "&name=" + name + "&state=60",
      });
    },
    //查看详情
    todetails(e, title) {
      var id = e;
      if (this.table == 2) {
        this.$router.push({
          path: "/parcel/parcelDetail?id=" + id + "&name=待确认",
        });
      } else {
        this.$router.push({
          path:
            "/extractGoods/details?id=" +
            id +
            "&name=待确认批次" +
            "&title=" +
            title,
        });
      }
    },
    productInformation() {
      this.$router.push({ name: "information" });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.transportation_box_l >>> .el-badge__content {
  background-color: #ff6003 !important;
}
.transportation_box_l >>> .el-badge__content.is-fixed {
  top: 0 !important;
  right: 0px !important;
}
.el-badge {
  width: 62px;
  height: 62px;
  display: block;
  margin: 0 auto 10px;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.table_item_box_l_s .el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  /* align-items: flex-end; */

  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
.transportation_box {
  width: 100px;
  margin: 0 18px 10px;
  /* margin-right: 100px; */
  cursor: pointer;
}
.transportation_box:hover img {
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.2);
}
.text_iop {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #2e3136;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box_shadow {
  width: 66px !important;
  height: 66px !important;
  box-shadow: 0 5px 18px 0 rgba(0, 0, 0, 0.5);
}
.img_size {
  width: 62px;
  height: 62px;
  background: rgba(0, 0, 0, 0);
  border-radius: 50%;
  display: block;
  object-fit: cover;
  margin: 0 auto 10px;
}
.transportation_box_l {
  display: flex;
  flex-wrap: wrap;
}
.color1 {
  color: #5178ff !important;
}
</style>


// WEBPACK FOOTER //
// src/views/undetermined/undetermined.vue